import { useState } from "react";
import { X, Plus } from "lucide-react";

export const ChipInput = ({ label, hint, values = [], onChange, placeholder = "Type and press Enter", testId, accent = "teal", max = 12 }) => {
  const [draft, setDraft] = useState("");
  const add = () => {
    const parts = draft.split(/[,\n]/).map((s) => s.trim()).filter(Boolean);
    if (!parts.length) return;
    const next = [...values];
    parts.forEach((p) => { if (!next.some((v) => v.toLowerCase() === p.toLowerCase()) && next.length < max) next.push(p); });
    onChange(next);
    setDraft("");
  };
  const remove = (v) => onChange(values.filter((x) => x !== v));
  const chipCls = accent === "red" ? "bg-red-500/10 border-red-500/30 text-red-300" : "bg-ism-teal/10 border-ism-teal/30 text-ism-teal";

  return (
    <div data-testid={testId}>
      {label && <label className="text-sm text-gray-300 block mb-1">{label}</label>}
      {hint && <p className="text-xs text-gray-500 mb-2">{hint}</p>}
      <div className="flex flex-wrap gap-2 p-2 rounded-xl bg-white/5 border border-white/10 focus-within:border-ism-teal/50 transition-colors min-h-[48px]">
        {values.map((v) => (
          <span key={v} className={`flex items-center gap-1 text-xs px-2.5 py-1 rounded-full border ${chipCls}`} data-testid={`${testId}-chip`}>
            {v}
            <button onClick={() => remove(v)} className="opacity-60 hover:opacity-100" aria-label={`Remove ${v}`}><X className="h-3 w-3" /></button>
          </span>
        ))}
        <input
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(); } if (e.key === "Backspace" && !draft && values.length) remove(values[values.length - 1]); }}
          onBlur={add}
          placeholder={values.length ? "" : placeholder}
          className="flex-1 min-w-[140px] bg-transparent text-sm text-white placeholder:text-gray-600 outline-none px-1"
          data-testid={`${testId}-input`}
        />
        {draft && <button onClick={add} className="text-ism-teal"><Plus className="h-4 w-4" /></button>}
      </div>
    </div>
  );
};

export const Field = ({ label, hint, children }) => (
  <div>
    <label className="text-sm text-gray-300 block mb-1">{label}</label>
    {hint && <p className="text-xs text-gray-500 mb-2">{hint}</p>}
    {children}
  </div>
);

export const INPUT_CLS = "w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white placeholder:text-gray-600 focus:border-ism-teal/50 focus:outline-none transition-colors";
